<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
}

.form {
    width: 100%;
    max-width: 300px;
}

.form > * {
    display: block;
    width: 100%;
}

span {
    padding: 10px 0;
    text-align: center;
    color: red;
}
</style>

<template>
<div></div>
<div id="login" class="container">
    <h1 class="title">login</h1>
    <div class="form">
        <label>email</label>
        <input v-model="input.email" type="text" placeholder="email" @keyup.enter="login" />
        <label>password</label>
        <input v-model="input.password" type="password" placeholder="password" @keyup.enter="login" />
        <button @click="login"> login </button>
        <span> {{ error_message }} </span>
    </div>
    <div>
    </div>
    <div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import { auth } from '../core/auth.js';
export default {
    name: 'Login',
    data() {
        return {
            input: {
                email: '',
                password: '',
            },
            error_message: '',
            myAuth: auth.session,
        };
    },
    methods: {
        login: async function() {
            this.error_message = '';
            let { error } = await auth.login({ ...this.input });
            if (error) {
                this.error_message = _.startCase(error);
                return;
            }
            this.$router.push('/');
        },
    }
};
</script>
